// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

// REF: https://github.com/w3c/media-capabilities/blob/main/explainer.md#decode-capabilities
// REF: https://en.wikipedia.org/wiki/HDR10
// REF: https://quantizationbit.github.io/av1-hdr10plus/
// HDR10 → HdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq"
// HDR10+ → HdrMetadataType: "smpteSt2094-40", colorGamut: "rec2020", transferFunction: "pq"
// Dolby Vision → HdrMetadataType: "smpteSt2094-10", colorGamut: "rec2020", transferFunction: "pq"
// HLG → HdrMetadataType: undefined, colorGamut: "rec2020", transferFunction: "hlg"
export const kVideoCanvases: Array<{
        name: string,
        width: number,
        height: number,
        framerate: number,
        hasAlphaChannel: boolean,
        configurations: Array<{
                mimeType: string,
                codec: string,
                colorGamut: ColorGamut,
                transferFunction: TransferFunction,
                hdrMetadataType?: HdrMetadataType,
                test: { href: string },
        }>,
}> = [{
        name: "720p 30fps Landscape",
        width: 1280,
        height: 720,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.05M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@30-av01.0.05M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64001f",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@30-avc1.64001f.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L93.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@30-hev1.1.6.L93.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.31.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@30-vp09.00.31.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.31.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1280x720@30-vp09.02.31.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.05M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@30-av01.0.05M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e001f",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@30-avc1.6e001f.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L93.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@30-hev1.2.4.L93.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.31.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@30-vp09.02.31.10.webm" },
                }
        ],
}, {
        name: "720p 60fps Landscape",
        width: 1280,
        height: 720,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@60-av01.0.08M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640020",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@60-avc1.640020.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L120.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@60-hev1.1.6.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.40.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1280x720@60-vp09.00.40.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1280x720@60-vp09.02.40.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@60-av01.0.08M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0020",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@60-avc1.6e0020.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L120.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@60-hev1.2.4.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1280x720@60-vp09.02.40.10.webm" },
                },
        ],
}, {
        name: "720p 30fps Portrait",
        width: 720,
        height: 1280,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.05M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@30-av01.0.05M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64001f",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@30-avc1.64001f.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L93.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@30-hev1.1.6.L93.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.31.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@30-vp09.00.31.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.31.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "720x1280@30-vp09.02.31.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.05M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@30-av01.0.05M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e001f",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@30-avc1.6e001f.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L93.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@30-hev1.2.4.L93.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.31.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@30-vp09.02.31.10.webm" },
                }
        ],
}, {
        name: "720p 60fps Portrait",
        width: 720,
        height: 1280,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@60-av01.0.08M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640020",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@60-avc1.640020.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L120.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@60-hev1.1.6.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.40.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "720x1280@60-vp09.00.40.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "720x1280@60-vp09.02.40.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@60-av01.0.08M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0020",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@60-avc1.6e0020.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L120.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@60-hev1.2.4.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "720x1280@60-vp09.02.40.10.webm" },
                },
        ],
}, {
        name: "1080p 30fps Landscape",
        width: 1920,
        height: 1080,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@30-av01.0.08M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640028",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@30-avc1.640028.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.H120.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@30-hev1.1.6.H120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.40.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@30-vp09.00.40.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1920x1080@30-vp09.02.40.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@30-av01.0.08M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0028",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@30-avc1.6e0028.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L120.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@30-hev1.2.4.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@30-vp09.02.40.10.webm" },
                },
        ],
}, {
        name: "1080p 60fps Landscape",
        width: 1920,
        height: 1080,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.09M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@60-av01.0.09M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@60-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L123.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@60-hev1.1.6.L123.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.41.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1920x1080@60-vp09.00.41.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1920x1080@60-vp09.02.41.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.09M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@60-av01.0.09M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@60-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L123.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@60-hev1.2.4.L123.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1920x1080@60-vp09.02.41.10.webm" },
                },
        ],
}, {
        name: "1080p 30fps Portrait",
        width: 1080,
        height: 1920,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@30-av01.0.08M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640028",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@30-avc1.640028.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.H120.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@30-hev1.1.6.H120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.40.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@30-vp09.00.40.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1080x1920@30-vp09.02.40.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.08M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@30-av01.0.08M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@30-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L120.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@30-hev1.2.4.L120.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.40.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@30-vp09.02.40.10.webm" },
                },
        ],
}, {
        name: "1080p 60fps Portrait",
        width: 1080,
        height: 1920,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.09M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@60-av01.0.09M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@60-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L123.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@60-hev1.1.6.L123.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.41.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1080x1920@60-vp09.00.41.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1080x1920@60-vp09.02.41.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.09M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@60-av01.0.09M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@60-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L123.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@60-hev1.2.4.L123.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1080x1920@60-vp09.02.41.10.webm" },
                },
        ],
}, {
        name: "2k 30fps Landscape",
        width: 2560,
        height: 1440,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@30-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@30-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@30-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.41.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@30-vp09.00.41.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "2560x1400@30-vp09.02.41.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@30-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@30-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@30-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@30-vp09.02.41.10.webm" },
                },
        ],
}, {
        name: "2k 60fps Landscape",
        width: 2560,
        height: 1440,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@60-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@60-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@60-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.50.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2560x1400@60-vp09.00.50.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "2560x1400@60-vp09.02.50.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@60-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@60-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@60-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2560x1400@60-vp09.02.50.10.webm" },
                },
        ],
}, {
        name: "2k 30fps Portrait",
        width: 1440,
        height: 2560,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@30-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@30-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@30-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.41.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@30-vp09.00.41.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1400x2560@30-vp09.02.41.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@30-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@30-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@30-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.41.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@30-vp09.02.41.10.webm" },
                },
        ],
}, {
        name: "2k 60fps Portrait",
        width: 1440,
        height: 2560,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@60-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64002a",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@60-avc1.64002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@60-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.50.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "1400x2560@60-vp09.00.50.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "1400x2560@60-vp09.02.50.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@60-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e002a",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@60-avc1.6e002a.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@60-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "1400x2560@60-vp09.02.50.10.webm" },
                },
        ],
}, {
        name: "4k 30fps Landscape",
        width: 3840,
        height: 2160,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@30-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640033",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@30-avc1.640033.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@30-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.50.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@30-vp09.00.50.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "3840x2160@30-vp09.02.50.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@30-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0033",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@30-avc1.6e0033.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@30-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@30-vp09.02.50.10.webm" },
                },
        ],
}, {
        name: "4k 60fps Landscape",
        width: 3840,
        height: 2160,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.13M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@60-av01.0.13M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640034",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@60-avc1.640034.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L153.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@60-hev1.1.6.L153.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.51.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3840x2160@60-vp09.00.51.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.51.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "3840x2160@60-vp09.02.51.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.13M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@60-av01.0.13M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0034",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@60-avc1.6e0034.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L153.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@60-hev1.2.4.L153.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.51.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3840x2160@60-vp09.02.51.10.webm" },
                },
        ],
}, {
        name: "4k 30fps Portrait",
        width: 2160,
        height: 3840,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@30-av01.0.12M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640033",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@30-avc1.640033.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L150.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@30-hev1.1.6.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.50.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@30-vp09.00.50.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "2160x3840@30-vp09.02.50.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.12M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@30-av01.0.12M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0033",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@30-avc1.6e0033.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L150.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@30-hev1.2.4.L150.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.50.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@30-vp09.02.50.10.webm" },
                },
        ],
}, {
        name: "4k 60fps Portrait",
        width: 2160,
        height: 3840,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.13M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@60-av01.0.13M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.640034",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@60-avc1.640034.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L153.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@60-hev1.1.6.L153.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.51.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "2160x3840@60-vp09.00.51.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.51.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "2160x3840@60-vp09.02.51.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.13M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@60-av01.0.13M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e0034",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@60-avc1.6e0034.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L153.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@60-hev1.2.4.L153.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.51.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "2160x3840@60-vp09.02.51.10.webm" },
                },
        ],
}, {
        name: "6k 30fps Landscape",
        width: 6144,
        height: 3456,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@30-av01.0.16M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003c",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@30-avc1.64003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L180.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@30-hev1.1.6.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.52.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@30-vp09.00.52.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "6144x3456@30-vp09.02.52.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@30-av01.0.16M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003c",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@30-avc1.6e003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L180.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@30-hev1.2.4.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@30-vp09.02.52.10.webm" },
                },
        ],
}, {
        name: "6k 60fps Landscape",
        width: 6144,
        height: 3456,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@60-av01.0.17M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003d",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@60-avc1.64003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L183.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@60-hev1.1.6.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.61.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "6144x3456@60-vp09.00.61.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "6144x3456@60-vp09.02.61.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@60-av01.0.17M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003d",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@60-avc1.6e003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L183.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@60-hev1.2.4.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "6144x3456@60-vp09.02.61.10.webm" },
                },
        ],
}, {
        name: "6k 30fps Portrait",
        width: 3456,
        height: 6144,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@30-av01.0.16M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003c",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@30-avc1.64003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L180.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@30-hev1.1.6.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.52.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@30-vp09.00.52.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "3456x6144@30-vp09.02.52.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@30-av01.0.16M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003c",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@30-avc1.6e003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L180.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@30-hev1.2.4.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@30-vp09.02.52.10.webm" },
                },
        ],
}, {
        name: "6k 60fps Portrait",
        width: 3456,
        height: 6144,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@60-av01.0.17M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003d",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@60-avc1.64003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L183.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@60-hev1.1.6.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.61.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "3456x6144@60-vp09.00.61.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "3456x6144@60-vp09.02.61.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@60-av01.0.17M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003d",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@60-avc1.6e003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L183.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@60-hev1.2.4.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "3456x6144@60-vp09.02.61.10.webm" },
                },
        ],
}, {
        name: "8k 30fps Landscape",
        width: 7680,
        height: 4320,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@30-av01.0.16M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003c",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@30-avc1.64003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L180.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@30-hev1.1.6.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.52.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@30-vp09.00.52.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "7680x4320@30-vp09.02.52.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@30-av01.0.16M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003c",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@30-avc1.6e003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L180.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@30-hev1.2.4.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@30-vp09.02.52.10.webm" },
                },
        ],
}, {
        name: "8k 60fps Landscape",
        width: 7680,
        height: 4320,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@60-av01.0.17M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003d",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@60-avc1.64003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L183.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@60-hev1.1.6.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.61.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "7680x4320@60-vp09.00.61.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "7680x4320@60-vp09.02.61.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@60-av01.0.17M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003d",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@60-avc1.6e003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L183.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@60-hev1.2.4.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "7680x4320@60-vp09.02.61.10.webm" },
                },
        ],
}, {
        name: "8k 30fps Portrait",
        width: 4320,
        height: 7680,
        framerate: 30,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@30-av01.0.16M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003c",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@30-avc1.64003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L180.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@30-hev1.1.6.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.52.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@30-vp09.00.52.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "4320x7680@30-vp09.02.52.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.16M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@30-av01.0.16M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003c",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@30-avc1.6e003c.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L180.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@30-hev1.2.4.L180.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.52.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@30-vp09.02.52.10.webm" },
                },
        ],
}, {
        name: "8k 60fps Portrait",
        width: 4320,
        height: 7680,
        framerate: 60,
        hasAlphaChannel: false,
        configurations: [
                // SDR
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@60-av01.0.17M.08.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.64003d",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@60-avc1.64003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.1.6.L183.b0",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@60-hev1.1.6.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.00.61.08",
                        colorGamut: "srgb", transferFunction: "srgb",
                        test: { href: "4320x7680@60-vp09.00.61.08.webm" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        colorGamut: "rec2020", transferFunction: "srgb",
                        test: { href: "4320x7680@60-vp09.02.61.10.webm" },
                },
                // HDR10
                {
                        mimeType: "video/mp4", codec: "av01.0.17M.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@60-av01.0.17M.10.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "avc1.6e003d",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@60-avc1.6e003d.mp4" },
                },
                {
                        mimeType: "video/mp4", codec: "hev1.2.4.L183.b0",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@60-hev1.2.4.L183.b0.mp4" },
                },
                {
                        mimeType: "video/webm", codec: "vp09.02.61.10",
                        hdrMetadataType: "smpteSt2086", colorGamut: "rec2020", transferFunction: "pq",
                        test: { href: "4320x7680@60-vp09.02.61.10.webm" },
                },
        ],
}];

// REF: https://dashif.org/codecs/audio/
export const kAudioCanvases: Array<{
        name: string,
        mimeType: string,
        codec: string,
        sample_rate: number,
        channels: number,
        test: { href: string },
}> = [
// WebM container formats
{
        name: "Opus",
        mimeType: "audio/webm",
        codec: "opus",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-opus.webm" },
}, {
        name: "Vorbis",
        mimeType: "audio/webm",
        codec: "vorbis",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-vorbis.webm" },
},

// MP4 container formats
{
        name: "MPEG-2 AAC Main Profile",
        mimeType: "audio/mp4",
        codec: "mp4a.66",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.66.mp4" },
}, {
        name: "MPEG-2 AAC LC Profile",
        mimeType: "audio/mp4",
        codec: "mp4a.67",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.67.mp4" },
//}, {
// REF: https://trac.ffmpeg.org/ticket/1693
//        name: "MPEG-2 AAC SSR Profile",
//        mimeType: "audio/mp4",
//        codec: "mp4a.68",
//        sample_rate: 48000,
//        channels: 2,
}, {
        name: "MPEG-2 extension to MPEG-1 (MP3)",
        mimeType: "audio/mp4",
        codec: "mp4a.69",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.69.mp4" },
}, {
        name: "MPEG-1 audio (MP3)",
        mimeType: "audio/mp4",
        codec: "mp4a.6B",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.6B.mp4" },
}, {
        name: "Opus",
        mimeType: "audio/mp4",
        codec: "opus",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-opus.mp4" },
}, {
        name: "MPEG-4 AAC LC Profile",
        mimeType: "audio/mp4",
        codec: "mp4a.40.2",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.40.2.mp4" },
}, {
        name: "MPEG-4 HE-AAC v1 Profile",
        mimeType: "audio/mp4",
        codec: "mp4a.40.5",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.40.5.mp4" },
}, {
        name: "MPEG-4 HE-AAC v2 Profile",
        mimeType: "audio/mp4",
        codec: "mp4a.40.29",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.40.29.mp4" },
}, {
        name: "AC-3",
        mimeType: "audio/mp4",
        codec: "ac-3",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-ac-3.mp4" },
}, {
        name: "AC-3",
        mimeType: "audio/mp4",
        codec: "mp4a.A5",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.A5.mp4" },
}, {
        name: "Enhanced AC-3",
        mimeType: "audio/mp4",
        codec: "ec-3",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-ec-3.mp4" },
}, {
        name: "Enhanced AC-3",
        mimeType: "audio/mp4",
        codec: "mp4a.A6",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.A6.mp4" },
//}, {
// REF: https://trac.ffmpeg.org/ticket/8349
//        name: "AC-4",
//        mimeType: "audio/mp4",
//        codec: "mp4a.AE",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mp4a.AE.mp4" }
}, {
        name: "DTS core",
        mimeType: "audio/mp4",
        codec: "dtsc",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-dtsc.mp4" },
}, {
        name: "DTS core",
        mimeType: "audio/mp4",
        codec: "mp4a.A9",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-mp4a.A9.mp4" },
}, {
        name: "DTS-HD core+extension",
        mimeType: "audio/mp4",
        codec: "dtsh",
        sample_rate: 48000,
        channels: 2,
        test: { href: "48000Hz-2ch-dtsh.mp4" },
//}, {
// REF: https://lists.ffmpeg.org/pipermail/ffmpeg-devel/2016-April/193601.html
//        name: "DTS-HD LBR",
//        mimeType: "audio/mp4",
//        codec: "dtse",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-dtse.mp4" },
//}, {
// REF: https://lists.ffmpeg.org/pipermail/ffmpeg-devel/2023-April/308544.html
//        name: "DTS-UHD Profile 2",
//        mimeType: "audio/mp4",
//        codec: "dtsx",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-dtsx.mp4" },
//}, {
//        name: "DTS-UHD Profile 3",
//        mimeType: "audio/mp4",
//        codec: "dtsy",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-dtsy.mp4" },
//}, {
// REF: https://lists.ffmpeg.org/pipermail/ffmpeg-devel/2019-November/253226.html
//        name: "MPEG-H Audio LC Profile Level 1",
//        mimeType: "audio/mp4",
//        codec: "mhm1.0x0B",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm1.0x0B.mp4" },
//}, {
//        name: "MPEG-H Audio LC Profile Level 2",
//        mimeType: "audio/mp4",
//        codec: "mhm1.0x0C",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm1.0x0C.mp4" },
//}, {
//        name: "MPEG-H Audio LC Profile Level 3",
//        mimeType: "audio/mp4",
//        codec: "mhm1.0x0D",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm1.0x0D.mp4" },
//}, {
//        name: "MPEG-H Audio LC Profile Level 1 multistream",
//        mimeType: "audio/mp4",
//        codec: "mhm2.0x0B",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm2.0x0B.mp4" },
//}, {
//        name: "MPEG-H Audio LC Profile Level 2 multistream",
//        mimeType: "audio/mp4",
//        codec: "mhm2.0x0C",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm2.0x0C.mp4" },
//}, {
//        name: "MPEG-H Audio LC Profile Level 3 multistream",
//        mimeType: "audio/mp4",
//        codec: "mhm2.0x0D",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mhm2.0x0D.mp4" },
//}, {
// REF: https://trac.ffmpeg.org/ticket/8411
// REF: https://ffmpeg.org/pipermail/ffmpeg-devel/2024-May/327703.html
//        name: "MPEG-D USAC (xHE-AAC)",
//        mimeType: "audio/mp4",
//        codec: "mp4a.40.42",
//        sample_rate: 48000,
//        channels: 2,
//        test: { href: "48000Hz-2ch-mp4a.40.42.mp4" },
}];

export const kImageCanvases: Array<{
        name: string,
        mimeType: string,
        max_width: number,
        max_height: number,
        configurations: Array<{
                width: number,
                height: number,
                test: { href: string },
        }>,
        has_alpha_channel: boolean,
        has_animation: boolean,
        has_lossless: boolean,
        has_transfer_function: boolean,
}> = [{
        name: "WebP Landscape",
        mimeType: "image/webp",
        max_width: 16383,
        max_height: 16383,
        configurations: [
                { width: 15360, height: 8640, test: { href: "15360x8640.webp" } },
                { width: 7680, height: 4320,  test: { href: "7680x4320.webp" } },
                { width: 3840, height: 2160,  test: { href: "3840x2160.webp" } },
                { width: 2560, height: 1440,  test: { href: "2560x1440.webp" } },
                { width: 1920, height: 1080,  test: { href: "1920x1080.webp" } },
                { width: 1280, height: 720,   test: { href: "1280x720.webp" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: false,
}, {
        name: "WebP Portrait",
        mimeType: "image/webp",
        max_width: 16383,
        max_height: 16383,
        configurations: [
                { width: 8640, height: 15360, test: { href: "8640x15360.webp" } },
                { width: 4320, height: 7680,  test: { href: "4320x7680.webp" } },
                { width: 2160, height: 3840,  test: { href: "2160x3840.webp" } },
                { width: 1440, height: 2560,  test: { href: "1440x2560.webp" } },
                { width: 1080, height: 1920,  test: { href: "1080x1920.webp" } },
                { width: 720, height: 1280,   test: { href: "720x1280.webp" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: false,
}, {
        name: "JPEG Landscape",
        mimeType: "image/jpeg",
        max_width: 65535,
        max_height: 65535,
        configurations: [
                { width: 15360, height: 8640, test: { href: "15360x8640.jpeg" } },
                { width: 7680, height: 4320,  test: { href: "7680x4320.jpeg" } },
                { width: 3840, height: 2160,  test: { href: "3840x2160.jpeg" } },
                { width: 2560, height: 1440,  test: { href: "2560x1440.jpeg" } },
                { width: 1920, height: 1080,  test: { href: "1920x1080.jpeg" } },
                { width: 1280, height: 720,   test: { href: "1280x720.jpeg" } },
        ],
        has_alpha_channel: false,
        has_animation: false,
        has_lossless: false,
        has_transfer_function: false,
}, {
        name: "JPEG Portrait",
        mimeType: "image/jpeg",
        max_width: 65535,
        max_height: 65535,
        configurations: [
                { width: 8640, height: 15360, test: { href: "8640x15360.jpeg" } },
                { width: 4320, height: 7680,  test: { href: "4320x7680.jpeg" } },
                { width: 2160, height: 3840,  test: { href: "2160x3840.jpeg" } },
                { width: 1440, height: 2560,  test: { href: "1440x2560.jpeg" } },
                { width: 1080, height: 1920,  test: { href: "1080x1920.jpeg" } },
                { width: 720, height: 1280,   test: { href: "720x1280.jpeg" } },
        ],
        has_alpha_channel: false,
        has_animation: false,
        has_lossless: false,
        has_transfer_function: false,
}, {
        name: "PNG Landscape",
        mimeType: "image/png",
        max_width: 2147483647,
        max_height: 2147483647,
        configurations: [
                { width: 15360, height: 8640, test: { href: "15360x8640.png" } },
                { width: 7680, height: 4320,  test: { href: "7680x4320.png" } },
                { width: 3840, height: 2160,  test: { href: "3840x2160.png" } },
                { width: 2560, height: 1440,  test: { href: "2560x1440.png" } },
                { width: 1920, height: 1080,  test: { href: "1920x1080.png" } },
                { width: 1280, height: 720,   test: { href: "1280x720.png" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: false,
}, {
        name: "PNG Portrait",
        mimeType: "image/png",
        max_width: 2147483647,
        max_height: 2147483647,
        configurations: [
                { width: 8640, height: 15360, test: { href: "8640x15360.png" } },
                { width: 4320, height: 7680,  test: { href: "4320x7680.png" } },
                { width: 2160, height: 3840,  test: { href: "2160x3840.png" } },
                { width: 1440, height: 2560,  test: { href: "1440x2560.png" } },
                { width: 1080, height: 1920,  test: { href: "1080x1920.png" } },
                { width: 720, height: 1280,   test: { href: "720x1280.png" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: false,
}, {
        name: "AVIF Landscape",
        mimeType: "image/avif",
        max_width: 65536,
        max_height: 65536,
        configurations: [
                { width: 15360, height: 8640, test: { href: "15360x8640.avif" } },
                { width: 7680, height: 4320,  test: { href: "7680x4320.avif" } },
                { width: 3840, height: 2160,  test: { href: "3840x2160.avif" } },
                { width: 2560, height: 1440,  test: { href: "2560x1440.avif" } },
                { width: 1920, height: 1080,  test: { href: "1920x1080.avif" } },
                { width: 1280, height: 720,   test: { href: "1280x720.avif" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: true,
}, {
        name: "AVIF Portrait",
        mimeType: "image/avif",
        max_width: 65536,
        max_height: 65536,
        configurations: [
                { width: 8640, height: 15360, test: { href: "8640x15360.avif" } },
                { width: 4320, height: 7680,  test: { href: "4320x7680.avif" } },
                { width: 2160, height: 3840,  test: { href: "2160x3840.avif" } },
                { width: 1440, height: 2560,  test: { href: "1440x2560.avif" } },
                { width: 1080, height: 1920,  test: { href: "1080x1920.avif" } },
                { width: 720, height: 1280,   test: { href: "720x1280.avif" } },
        ],
        has_alpha_channel: true,
        has_animation: true,
        has_lossless: true,
        has_transfer_function: true,
}];
